module.exports = __webpack_public_path__ + "img/user_call.45662e62.jpg";